
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"1726850ec5087433ec51c984a73b1688721b46d9":"$$ACTION_0","4ea8fd3afad07df07274f70784ff774390c64b68":"updateProfile","9d2d3b0e33d9719547ed370460714512f9f1a335":"GetImageUrl","adc35621ca93796cf83426a9502b75d73377bcc1":"UpdateAvatar","cb2c629ed713980513a5a892d976acd5581fde46":"UploadAvatar"} */ export var UpdateAvatar = createServerReference("adc35621ca93796cf83426a9502b75d73377bcc1");
import { createServerReference } from "private-next-rsc-action-client-wrapper";
export var updateProfile = createServerReference("4ea8fd3afad07df07274f70784ff774390c64b68");
export var GetImageUrl = createServerReference("9d2d3b0e33d9719547ed370460714512f9f1a335");
export var UploadAvatar = createServerReference("cb2c629ed713980513a5a892d976acd5581fde46");

